import React, { Component } from "react";

import Api from "../../lib/componentApi";
import getAppStrings from "../../lib/appStrings";
import getItemOptions from "../../lib/getItemOptions";

import AppInfo from "../../components/Common/AppInfo";

export default class DesktopCheckout extends Component {
  state = {
    removeItemDialog: false,
    itemName: "",
    basketItemId: null,
    itemQuantity: 1
  };

  removeItem = (basketItemId, itemQuantity, itemName) => {
    const { updateBasket, getRestaurantItems } = this.props;
    const { removeItemDialog } = this.state;

    if (basketItemId) {
      if (removeItemDialog) {
        Api.post(
          "/api/product/item/delete",
          { basketItemId, quantity: itemQuantity },
          (response, errors) => {
            if (errors) {
              if (errors === 503) {
                this.setState(() => {
                  throw errors;
                });
              } else {
                console.log(errors);
              }
            } else if (response.code) {
              updateBasket(null, true);
              console.log(response.code, "delete-item-code");
            } else {
              let callback = null;
              getRestaurantItems();
              if (response.status) {
                callback = () => updateBasket(response.basket);
              } else {
                callback = () => updateBasket(null, true);

                console.log("response status false delete basket item on bar");
              }
              getRestaurantItems(callback);
            }
            this.setState({
              itemName: "",
              basketItemId: null,
              itemQuantity: 1,
              removeItemDialog: false
            });
          }
        );
      } else {
        this.setState({
          removeItemDialog: true,
          itemName,
          basketItemId,
          itemQuantity
        });
      }
    }
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this), false);
  }
  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateDimensions.bind(this),
      false
    );
  }
  getSnapshotBeforeUpdate(prevProps) {
    if (prevProps.scrolled !== this.props.scrolled) {
      this.updateDimensions();
    }
    return null;
  }

  updateDimensions() {
    let totalHeight = 400;
    const { scrolled } = this.props;
    if (scrolled) {
      const menu = document.querySelector(".menu-filter");
      if (menu) {
        const menuHeight = menu.offsetHeight;
        totalHeight = totalHeight + menuHeight + 40;
      }
    }
    const innerHeight = window.innerHeight - totalHeight;
    const querySelector = document.querySelector(".basket-body__scroll");
    if (querySelector) {
      querySelector.style.maxHeight = innerHeight + "px";
    }
  }

  getRenderBasketData = (basketData, allAmount) => {
    return (
      <React.Fragment>
        <div className="basket-body__scroll">
          {basketData.items.length &&
            basketData.items.map(item => (
              <React.Fragment key={item.id}>
                <div className="d-flex justify-content-between item-div">
                  <div>
                    <span className="item-quantity">{item.quantity}x</span>
                  </div>
                  <p>{item.name}</p>
                  <div className="pricing d-flex align-items-center">
                    <p>£{parseFloat(item.totalAmount).toFixed(2)}</p>
                    <a
                      href="javascript:void(0)"
                      className="close"
                      onClick={() =>
                        this.removeItem(item.id, item.quantity, item.name)
                      }
                    >
                      <icon className="icon icon-close" />
                    </a>
                  </div>
                </div>
                <p className="small-label">
                  {getItemOptions(basketData, item.id)}
                </p>
              </React.Fragment>
            ))}
        </div>
        <div className="d-flex justify-content-between align-items-center total">
          <p>Total</p>
          <p>£{parseFloat(allAmount).toFixed(2)}</p>
        </div>
      </React.Fragment>
    );
  };
  onClickClose = () => {
    this.setState({
      itemName: "",
      basketItemId: null,
      itemQuantity: 1,
      removeItemDialog: false
    });
  };
  getInfoMessage = () => {
    const { itemName } = this.state;
    const appString = getAppStrings(4034);
    let message;
    if (appString && appString.message && itemName) {
      message = appString.message.replace("[:par1]", `${itemName}`);
    } else {
      message = "Are you sure you want to delete this product?";
    }
    return message;
  };
  render() {
    const { basketData } = this.props;
    const { restaurant } = basketData;
    const allAmount = (basketData && basketData.subTotal) || 0;
    let restaurantCity = (restaurant && restaurant.address.city.slugName) || "";
    let href =
      (restaurant &&
        restaurant.address &&
        `/restaurant/${restaurantCity}/${restaurant.address.slugAdminWard}/${restaurant.slugName}`) ||
      null;
    const {
      itemName,
      removeItemDialog,
      basketItemId,
      itemQuantity
    } = this.state;
    const message = this.getInfoMessage();
    const buttonText = "Remove";
    return (
      <>
        <div className="title-small">
          <div className="d-flex align-items-center">
            <div>
              <i className="icon icon-basket" />
            </div>
            <div className="flex-grow-1">
              {(href && <a href={href}>{restaurant.name}</a>) || <a>Basket</a>}
            </div>
          </div>
        </div>
        {removeItemDialog && (
          <AppInfo
            message={message}
            title="Remove Item"
            onClickClose={() => this.onClickClose()}
            buttonText={buttonText}
            onSubmit={() =>
              this.removeItem(basketItemId, itemQuantity, itemName)
            }
          />
        )}
        <div className="white-bg basket-body">
          {(basketData && this.getRenderBasketData(basketData, allAmount)) || (
            <div className="basket-empty">
              <i className="icon icon-basket-gray" />
              <label className="small-label">Your basket is empty!</label>
            </div>
          )}
        </div>
        <a
          href="/checkout"
          className={(basketData && "btn btn-blue") || "btn btn-gray"}
        >
          Check Out
        </a>
      </>
    );
  }
}
